import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/password-validator/password-validator.styles.ts
var password_validator_styles_default = r` ${component_styles_default} .password-validator-badges { display: flex; } fadv-badge { flex: 1; margin: 2px; } fadv-badge::part(base) { width: 100%; } fadv-badge:first-child::part(base) { margin-left: 0; } fadv-badge:last-child::part(base) { margin-right: 0; } fadv-badge::part(base) { padding-top: 0; padding-bottom: 0; height: 6px; } fadv-badge.password-validator-badge-error::part(base) { border: 1px solid var(--sl-color-gray-700); background: var(--sl-color-neutral-0); } fadv-badge[variant='success']::part(base) { border: 1px solid var(--badge-background-success); } fadv-badge[variant='warning']::part(base) { border: 1px solid var(--badge-background-warning); } fadv-badge[variant='danger']::part(base) { border: 1px solid var(--badge-background-danger); } `;

export {
  password_validator_styles_default
};
